export const menuItems = [
  { name: 'about', label: 'About Us' },
  { name: 'services', label: 'Services' },
  { name: 'pricing', label: 'Pricing' },
  { name: 'faq', label: 'FAQ' },
  { name: 'contact', label: 'Contact' }
];
